

import React from 'react';
import { withRouter } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';

import { ApolloConsumer } from 'react-apollo';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import RequestProvider from '../../RequestProvider';
import {
  getOrgTotalEngagementsQuery,
  getOrgHighestEngagementsQuery } from
'../queries';
import { getRacetrackAnalyticsQuery } from '../../Racetrack/queries';
import RightDrawerInsightsComponent from '../components/RightDrawerInsights';










function RightDrawerInsights(props) {
  return (
    <ApolloConsumer>
      {(apolloClient) =>
      <AuthorisationConsumer>
          {({ selectedOrganisation: { organisationId, billingEntityCode } }) =>
        <RequestProvider
          requests={{
            getOrgTotalEngagements: getOrgTotalEngagementsQuery(organisationId),
            getOrgHighestEngagements: getOrgHighestEngagementsQuery(organisationId),
            getRacetrackAnalytics: getRacetrackAnalyticsQuery(organisationId)
          }}>

              {(requests) =>
          <SizeMe>
                  {({ size: { width } = { width: 0 } }) =>
            <RightDrawerInsightsComponent
              width={width}
              {...requests}
              {...props}
              apolloClient={apolloClient}
              billingEntityCode={billingEntityCode} />}


                </SizeMe>}

            </RequestProvider>}

        </AuthorisationConsumer>}

    </ApolloConsumer>);

}

export default withRouter(RightDrawerInsights);